module.exports = __webpack_public_path__ + "static/media/twitter.43449f1c.svg";